import type { AchievementCondition } from '@/entities/achievement';

/**
 * Подпись условия для полосы прогресса.
 *
 * Текст приходит с сервера (`condition.label`) — там же, где живут
 * сужения условия из `params`. Здесь остаётся только раскладка макета:
 * число цели, разделитель и правило «подпись показывается лишь у Ачивки
 * с несколькими условиями» — у одноусловной её дублирует текст самой
 * Ачивки (узел 438:48230).
 */
export function conditionLabel(
  condition: AchievementCondition,
  totalConditions: number,
): string | null {
  if (totalConditions < 2) return null;
  return `${String(condition.targetValue)} · ${condition.label}`;
}

/**
 * Сколько сегментов рисовать.
 *
 * Вёрстка рисует по элементу на единицу цели, а `POINTS_TOTAL` измеряется
 * тысячами — буквальное следование положило бы экран десятью тысячами
 * узлов. Выше потолка показываем долю: точное число в макете нигде
 * не выводится, так что смысл не теряется.
 *
 * Потолок 50 — по макету Селебы (узел 1020:7705): 50 реакций рисуются
 * 50 делениями по 3,24 px. До 06.10.2026 потолок был 20, и Селеба
 * с Комментатором сжимались в долю вместо деления на единицу.
 *
 * Доля округляется ВНИЗ: полная полоса обязана значить «выполнено».
 * С округлением до ближайшего 49 из 50 при 20 делениях давали
 * 19,6 → 20, и игрок видел полную полосу без награды.
 */
export const MAX_SEGMENTS = 50;

export function segmentsOf(condition: AchievementCondition): {
  segments: number;
  filled: number;
} {
  const { targetValue, currentValue } = condition;
  if (targetValue <= MAX_SEGMENTS) {
    return {
      segments: Math.max(targetValue, 1),
      filled: Math.min(currentValue, targetValue),
    };
  }

  const ratio = targetValue === 0 ? 0 : currentValue / targetValue;
  return {
    segments: MAX_SEGMENTS,
    filled: Math.min(Math.floor(ratio * MAX_SEGMENTS), MAX_SEGMENTS),
  };
}
